/**
 * Single gate for the post-sync "reboot now to apply?" prompt (used by the
 * About-page landing effect, the About-page Sync handler, and the edit-view
 * sync flow, so they can't drift).
 *
 * A "reboot" on this prompt is `customer/{id}/action/arm` — it ARMS the site.
 * That is only the right offer when the site is armed AND it is *meant* to be
 * armed right now. After a schedule save disarms a site, `armed` still reads
 * true for up to a poller cycle (it derives from lagging motion status), so
 * gating on `armed` alone offered a "reboot" on a site the operator's own
 * schedule had just turned off — and clicking Yes armed it outside its
 * schedule as a manual_start the reconciler correctly leaves alone
 * (SUP-311 / ENG-811: 43 such re-arms across 39 sites in 14 days).
 *
 * `arm_intended` is admin's intent flag: schedule in-window OR an active
 * manual arm. The manual-arm half matters — a site the operator deliberately
 * armed off-schedule and then edited settings on must still be offered the
 * reboot, or it silently runs stale settings until a boundary hours away.
 * When the field is absent (older admin), fall back to `armed` — the
 * pre-existing behavior — rather than suppressing the prompt everywhere.
 */
export const shouldOfferRebootToApply = (
  site: { armed?: boolean; arm_intended?: boolean } | null | undefined
): boolean => {
  if (!site?.armed) return false;
  if (typeof site.arm_intended === "boolean") return site.arm_intended;
  return true;
};
